import { loadJSON } from "./getJSON";
import Mustache from "mustache";

function alertCheck(data) {
  loadJSON("https://apps.library.vcu.edu/alertme/feed", (data) => {
		if (data.error || data[0] == null) {
			return data;
		}

		function alertData(data) {
			return data;
		}
		$.get("https://apps.library.vcu.edu/pub_scripts/js/templates/alerts.html", function (template) {
			var body = $("body");
			var rendered = Mustache.render(template, {
				title: data[0].title,
				url: data[0].url,
				description: data[0].description,
			});
			body.prepend(rendered);
		});
	});
}

export { alertCheck };
